import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const useBookingInquiryViewerDelete = (d2dNo: string, id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await bookingInquiryApis.delete('/booking-inquiry/can-view/{id}/', {
        path: { id },
      });
      return response[204];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/booking-inquiry/${d2dNo}/`]);
      },
    },
  );
};
